import { useEffect, useRef } from 'react';

export const useResizeObserver = <T extends HTMLElement = HTMLDivElement>(
  callback: (contentRect: DOMRectReadOnly) => void,
  customRef?: React.RefObject<T | null>,
) => {
  const internalRef = useRef<T | null>(null);
  const ref = customRef || internalRef;

  useEffect(() => {
    if (!ref.current) return;

    const resizeObserverCallback: ResizeObserverCallback = (entries) => {
      const element = entries[0].target;

      callback(element.getBoundingClientRect());
    };

    const resizeObserver = new ResizeObserver(resizeObserverCallback);

    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref.current, callback]);

  return [ref] as const;
};
